import ApiaField from '../ApiaField';
import ApiaForm from '../ApiaForm';
import Field from '../constants/Field';
import { IApiaField } from '../types';

export interface ITextField extends IApiaField {
  getLabel(): void;
}

export default class TextField extends ApiaField implements ITextField {
  constructor(field: HTMLDivElement, form: ApiaForm) {
    super(field, form, [Field.PROPERTY_BOLD, Field.PROPERTY_UNDERLINED]);
  }

  getLabel(): void {
    throw new Error(
      `Apia JSApi Error: The field ${
        this.fldType as string
      } does not use a label`,
    );
  }
}
